export var RenderDrawMode;
(function (RenderDrawMode) {
    RenderDrawMode[RenderDrawMode["TRIANGLES"] = 0] = "TRIANGLES";
    RenderDrawMode[RenderDrawMode["POINTS"] = 1] = "POINTS";
    RenderDrawMode[RenderDrawMode["LINES"] = 2] = "LINES";
})(RenderDrawMode || (RenderDrawMode = {}));
